import type { RequestDocument } from 'graphql-request';

export const PERSON_BY_EMAIL_QUERY: RequestDocument = `query getPersonByEmail($email: String!) {
  allPeople(filter: {email: {eq: $email}}) {
    id
    name
    email
    title
    phone
    user
    favoritePrompts
    zoomInfo
  }
}`;

export const PERSON_BY_NAME_QUERY: RequestDocument = `query getPersonByName($name: String!) {
  allPeople(filter: {name: {matches: {pattern: $name}}}) {
    id
    title
  }
}`;

export const ORGS_THAT_PERSON_BELONGS_TO_QUERY = `query getPersonOrganizations($personId: ItemId!) {
  allShowcases(
    filter: {
      OR: [
        { allowList: { anyIn: [$personId] } },
        { adminList: { anyIn: [$personId] } }
      ]
    }
  ) {
    id
    title
    organization
    slug
    logo {
      url
    }
    mainImage {
      url
    }
  }
}`;
